

// import { useEffect, useState } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import Header from "./Header";
// import FileUploadModal from "./FileUploadModal";
// // import { listSessions } from "../api";
// import img1 from '../assets/avatars/1.png'
// import img2 from '../assets/avatars/2.png'
// import img3 from '../assets/avatars/3.png'
// import defaultImg from '../assets/avatars/2.png'
// import { listSessions, createSession } from "../api";



// export default function SecondPage() {
//   const { id } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [agentDetails, setAgentDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
//   const [creatingSession, setCreatingSession] = useState(false);
  
//   useEffect(() => {
//     // First, try to get data from navigation state (passed from previous page)
    
//     if (location.state?.agentData) {

//       const agent = location.state.agentData;
//       setAgentDetails({
//         agent_name: agent.agent_name ,
//         role: "Obesity Agent",
//         therapeutic_area: "General Medicine",
//         description: agent.description,
//         profile_image: defaultImg,
//         document_count: agent.pdf_count || 0,
//         created_at: agent.created_at,
//         expires_at: agent.expires_at
//       });
//       setLoading(false);
//     } else {
//       // Fallback: If user directly accessed this URL or refreshed, fetch from API
//       listSessions()
//         .then((data) => {
//           const agent = data.agents?.find(a => a.agent_id === id);
//           if (agent) {
//             setAgentDetails({
//               agent_name: agent.agent_name || "Unknown Agent",
//               role: "Medical Analyst",
//               therapeutic_area: "General Medicine",
//               description: "AI-powered medical analyst specialized in document analysis and insights generation.",
//               profile_image: null,
//               document_count: agent.pdf_count || 0,
//               created_at: agent.created_at,
//               expires_at: agent.expires_at
//             });
//           } else {
//             console.error("Agent not found");
//             setAgentDetails(null);
//           }
//         })
//         .catch((err) => {
//           console.error("Error fetching session details:", err);
//           setAgentDetails(null);
//         })
//         .finally(() => setLoading(false));
//     }
//   }, [id, location.state]);

//   const handleBack = () => {
//     navigate("/");
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-white">
//         <Header />
//         <div className="text-center p-10 text-gray-600 mt-20">Loading agent details...</div>
//       </div>
//     );
//   }

//   // Generate avatar if no image provided
//   const avatarUrl = agentDetails.profile_image || 
//     `https://ui-avatars.com/api/?name=${encodeURIComponent(agentDetails.agent_name)}&size=241&background=E8F0FE&color=4F39F6&bold=true&format=svg`;


//     const handleTalkToAgent = async () => {
//   setCreatingSession(true);
  
//   try {
//     // Create session with agent_id and agent name
//     const payload = {
//       agent_id: id,
//       session_name: agentDetails.agent_name
//     };
    
//     console.log("Creating session with payload:", payload);
//     const sessionResponse = await createSession(payload);
//     console.log("Session created:", sessionResponse.data);
    
//     // Navigate to conversation page with the new session ID
//     if (sessionResponse.data?.session_id) {
//       navigate(`/conversation/${sessionResponse.data.session_id}`, {
//         state: {
//           uploadResponse: null, // No upload response for talk-only mode
//           agentId: id,
//           agentName: agentDetails.agent_name
//         }
//       });
//     }
    
//   } catch (error) {
//     console.error("Error creating session:", error);
//     alert("Error creating session. Please try again.");
//   } finally {
//     setCreatingSession(false);
//   }
// };


//   return (
//     <div className="min-h-screen bg-white">
//       {/* Header */}
//       {/* <Header /> */}

//       {/* Main Content - Fixed positioning to avoid overlap */}
//       <div className="flex gap-6 px-[120px] pt-[117px] pb-8">
//         {/* Left Side - Agent Profile */}
//         <div className="flex flex-col gap-6 w-[241px] flex-shrink-0">
//           {/* Agent Image */}
//           <div 
//             className="w-[241px] h-[242px] rounded-lg bg-cover bg-center"
//             style={{ 
//               backgroundImage: `url(${avatarUrl})`,
//               backgroundColor: '#E8F0FE'
//             }}
//           />

//           {/* Agent Info Container */}
//           <div className="flex flex-col gap-6 w-[241px]">
//             {/* Agent Name */}
//             <h2 className="text-[20px] font-semibold leading-6 tracking-[0.003em] text-[#373737]">
//               {agentDetails.agent_name}
//             </h2>

//             {/* Details Section */}
//             <div className="flex flex-col gap-2">
//               {/* Role Badge */}
//               <div className="flex justify-center items-center px-3 py-1 bg-[#AAE8FB] rounded-[25px] w-fit">
//                 <p className="text-[#00546E] text-[16px] font-medium leading-[19px] tracking-[0.003em] text-center">
//                   {agentDetails.role}
//                 </p>
//               </div>

//               {/* Therapeutic Area */}
//               {/* <p className="text-[#9340FF] text-[16px] font-semibold leading-[19px] tracking-[0.003em]">
//                 {agentDetails.therapeutic_area}
//               </p> */}
//             </div>

//             {/* Description */}
//             <p className="text-[#373737] text-[16px] font-medium leading-[130%] tracking-[0.003em]">
//               {agentDetails.description}
//             </p>
//           </div>
//         </div>

//         {/* Right Side - Evaluation Options */}
//         <div className="flex flex-col gap-6 flex-1 max-w-[774px]">
//           {/* Title */}
//           <h1 className="text-[24px] font-bold leading-[29px] tracking-[0.003em] text-black">
//             Ways to Evaluate Obesity Agent 
//           </h1>
  
//             <div 
//               onClick={() => setIsUploadModalOpen(true)}
//               className="flex items-center gap-6 p-6 bg-[#F8F7FF] border border-[#E2E2E3] rounded-lg cursor-pointer hover:bg-[#F0EDFF] transition-colors"
//             >
//               <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
//                   <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="#4F39F6"/>
//                   <path d="M18 12C18 12.7956 17.8827 13.5587 17.6629 14.2765C17.443 14.9943 17.1262 15.6599 16.7279 16.2426C16.3296 16.8253 15.8551 17.3296 15.3235 17.7371C14.7918 18.1445 14.2087 18.451 13.5918 18.6481" stroke="#4F39F6" strokeWidth="2" strokeLinecap="round"/>
//                   <path d="M6 12C6 11.2044 6.11733 10.4413 6.33706 9.72346C6.55679 9.00571 6.87357 8.34007 7.27208 7.75736C7.67059 7.17465 8.14509 6.67037 8.67673 6.26293C9.20837 5.8555 9.79134 5.54901 10.4082 5.35188" stroke="#4F39F6" strokeWidth="2" strokeLinecap="round"/>
//                 </svg>
//               </div>
//               <span className="text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
//                 {/* Listen to {agentDetails.agent_name}'s Full Call */}
//                 Upload File
//               </span>
//             </div>

//           {/* Evaluation Options Container */}
//           <div className="flex flex-col gap-4">
//             {/* Audio Player with Waveform */}
           

//             {/* Listen to Full Call */}
          

//             {/* Review Safety Data
//             <div className="flex items-center gap-6 p-6 bg-[#F8F7FF] border border-[#E2E2E3] rounded-lg">
//               <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
//                   <path d="M12 2L3 7V12C3 16.55 6.84 20.74 12 22C17.16 20.74 21 16.55 21 12V7L12 2Z" fill="#4F39F6"/>
//                 </svg>
//               </div>
//               <span className="text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
//                 Review {agentDetails.agent_name}'s Safety Data
//               </span>
//             </div> */}

//             {/* Talk to Agent */}
// <div 
//   onClick={handleTalkToAgent}
//   className="flex items-center gap-6 p-6 bg-[#F8F7FF] border border-[#E2E2E3] rounded-lg cursor-pointer hover:bg-[#F0EDFF] transition-colors"
// >
//   <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
//     {creatingSession ? (
//       <svg className="animate-spin h-5 w-5 text-[#4F39F6]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
//       </svg>
//     ) : (
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
//         <path d="M20 15.5C21.3845 15.5 22.5 14.3845 22.5 13V11C22.5 9.61547 21.3845 8.5 20 8.5C18.6155 8.5 17.5 9.61547 17.5 11V13C17.5 14.3845 18.6155 15.5 20 15.5Z" fill="#4F39F6"/>
//         <path d="M4 15.5C5.38453 15.5 6.5 14.3845 6.5 13V11C6.5 9.61547 5.38453 8.5 4 8.5C2.61547 8.5 1.5 9.61547 1.5 11V13C1.5 14.3845 2.61547 15.5 4 15.5Z" fill="#4F39F6"/>
//         <path d="M20 13V12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12V13" stroke="#4F39F6" strokeWidth="2"/>
//       </svg>
//     )}
//   </div>
//   <span className="text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
//     {creatingSession ? "Creating session..." : `Talk to ${agentDetails.agent_name}`}
//   </span>
// </div>

           
//           </div>

//           {/* Action Buttons */}
//           <div className="flex gap-6">
//             <button 
//               onClick={handleBack}
//               className="flex-1 flex items-center justify-center px-2 py-2 h-11 bg-[#E6E2FF] rounded-lg"
//             >
//               <span className="text-[14px] font-semibold leading-[17px] text-[#4F39F6]">Explore Agents</span>
//             </button>
//             {/* <button className="flex-1 flex items-center justify-center px-2 py-2 h-11 bg-[#4F39F6] rounded-lg">
//               <span className="text-[14px] font-semibold leading-[17px] text-white">Proceed</span>
//             </button> */}
//           </div>
//         </div>
//       </div>

//       {/* File Upload Modal */}
//       <FileUploadModal
//         isOpen={isUploadModalOpen}
//         onClose={() => setIsUploadModalOpen(false)}
//         agentId={id}
//         agentName={agentDetails?.agent_name}
//       />
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import FileUploadModal from "./FileUploadModal";
import img1 from '../assets/avatars/1.png'
import img2 from '../assets/avatars/2.png'
import img3 from '../assets/avatars/3.png'
import defaultImg from '../assets/avatars/2.png';
import PoweredBySvg from "../assets/poweredBy.svg"
import { listSessions, createSession, listUserSessions } from "../api";
import DrAnikaImg from "../assets/dranika.png";

export default function SecondPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [agentDetails, setAgentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [creatingSession, setCreatingSession] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [creatingChat, setCreatingChat] = useState(false);
const [creatingTalk, setCreatingTalk] = useState(false);
  const [mySessions, setMySessions] = useState([]);
  const [sessionsLoading, setSessionsLoading] = useState(false);

  
  useEffect(() => {
    if (location.state?.agentData) {
      const agent = location.state.agentData;
      setAgentDetails({
        agent_name: agent.agent_name,
        role: "Obesity Specialist Agent",
        therapeutic_area: "General Medicine",
        description: agent.description,
        profile_image: defaultImg,
        document_count: agent.pdf_count || 0,
        created_at: agent.created_at,
        expires_at: agent.expires_at
      });
      setLoading(false);
    } else {
      listSessions()
        .then((data) => {
          const agent = data.agents?.find(a => a.agent_id === id);
          if (agent) {
            setAgentDetails({
              agent_name: agent.agent_name || "Unknown Agent",
              role: "Medical Analyst",
              therapeutic_area: "General Medicine",
              description: "AI-powered medical analyst specialized in document analysis and insights generation.",
              profile_image: null,
              document_count: agent.pdf_count || 0,
              created_at: agent.created_at,
              expires_at: agent.expires_at
            });
          } else {
            console.error("Agent not found");
            setAgentDetails(null);
          }
        })
        .catch((err) => {
          console.error("Error fetching session details:", err);
          setAgentDetails(null);
        })
        .finally(() => setLoading(false));
    }
  }, [id, location.state]);

  useEffect(() => {
    (async () => {
      try {
        setSessionsLoading(true);
        const data = await listUserSessions();
        console.log("Fetched user sessions:", data);
        const items =  data || [];
        const filtered = items.filter((s) => (s.agent_id === id));
        setMySessions(filtered);
      } catch (e) {
        console.error("Error fetching user sessions:", e);
      } finally {
        setSessionsLoading(false);
      }
    })();
  }, [id]);

  const handleBack = () => {
    navigate("/");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="text-center p-10 text-gray-600 mt-20">Loading agent details...</div>
      </div>
    );
  }

  const avatarUrl = agentDetails.profile_image || 
    `https://ui-avatars.com/api/?name=${encodeURIComponent(agentDetails.agent_name)}&size=241&background=E8F0FE&color=4F39F6&bold=true&format=svg`;

  // const handleCreateSession = async (interactionType) => {
  //   setCreatingSession(true);
    
  //   try {
  //     const payload = {
  //       agent_id: id,
  //       session_name: agentDetails.agent_name
  //     };
      
  //     console.log("Creating session with payload:", payload);
  //     const sessionResponse = await createSession(payload);
  //     console.log("Session created:", sessionResponse.data);
      
  //     if (sessionResponse.data?.session_id) {
  //       navigate(`/conversation/${sessionResponse.data.session_id}`, {
  //         state: {
  //           uploadResponse: null,
  //           agentId: id,
  //           agentName: agentDetails.agent_name,
  //           interactionType: interactionType, // "talk" or "chat"
  //           isTalkToAgent: interactionType === "talk"
  //         }
  //       });
  //     }
      
  //   } catch (error) {
  //     console.error("Error creating session:", error);
  //     alert("Error creating session. Please try again.");
  //   } finally {
  //     setCreatingSession(false);
  //   }
  // };
  const handleCreateSession = async (interactionType, setLoader) => {
  setLoader(true);
  
  try {
    const payload = {
      agent_id: id,
      session_name: agentDetails.agent_name,
    };

    console.log("Creating session with payload:", payload);
    const sessionResponse = await createSession(payload);
    console.log("Session created:", sessionResponse.data);

    if (sessionResponse.data?.session_id) {
      navigate(`/conversation/${sessionResponse.data.session_id}`, {
        state: {
          uploadResponse: null,
          agentId: id,
          agentName: agentDetails.agent_name,
          interactionType,
          isTalkToAgent: interactionType === "talk",
        },
      });
    }
  } catch (error) {
    console.error("Error creating session:", error);
    alert("Error creating session. Please try again.");
  } finally {
    setLoader(false);
  }
};


  // const handleTalkToAgent = async () => {
  //   await handleCreateSession("talk");
  // };

  // const handleChatWithAgent = async () => {
  //   await handleCreateSession("chat");
  // };
  const handleTalkToAgent = async () => {
  await handleCreateSession("talk", setCreatingTalk);
};

const handleChatWithAgent = async () => {
  await handleCreateSession("chat", setCreatingChat);
};


  const handleVideoCallWithAgent = () => {
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 2000);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 px-4 sm:px-6 md:px-12 lg:px-24 xl:px-32 pt-20 md:pt-24 pb-12 md:pb-16">
        {/* Left Side - Agent Profile */}
        <div className="flex flex-col gap-8 w-full lg:w-[280px] flex-shrink-0">
          <div className="w-full lg:w-[280px] h-56 md:h-64 rounded-xl overflow-hidden shadow-md">
            <img src={DrAnikaImg} alt="Dr. Anika" className="w-full h-full object-cover rounded-xl" />
          </div>

          <div className="flex flex-col gap-6 w-full lg:w-[280px]">
            <h2 className="text-[20px] md:text-[22px] font-semibold leading-7 tracking-[0.003em] text-[#373737]">
              {agentDetails.agent_name}
            </h2>

            <div className="flex flex-col gap-3">
              <div className="flex justify-center items-center px-4 py-1.5 bg-[#AAE8FB] rounded-[25px] w-fit">
                <p className="text-[#00546E] text-[14px] md:text-[16px] font-medium leading-[19px] tracking-[0.003em] text-center">
                  {agentDetails.role}
                </p>
              </div>
            </div>

            <p className="text-[#373737] text-[15px] md:text-[16px] font-normal leading-[150%] tracking-[0.003em]">
              {agentDetails.description}
            </p>
          </div>
          <div className="mt-2">
            <a href="https://curebay.com/" target="_blank" rel="noopener noreferrer">
              <img style={{
                width: "107px",
                height: "34px",
              }} className='mt-4' src={PoweredBySvg} alt='Powered By Curebay' />
            </a>
          </div>
        </div>

        {/* Right Side - Evaluation Options */}
        <div className="flex flex-col gap-8 flex-1 w-full lg:max-w-[800px]">
          <h1 className="text-[22px] md:text-[28px] font-bold leading-[34px] tracking-[0.003em] text-black">
            Ways to Evaluate Obesity Agent 
          </h1>
  
          {/* Upload File */}
          <div 
            // onClick={() => setIsUploadModalOpen(true)}
            className="flex items-center gap-6 p-6 md:p-7 bg-[#F8F7FF] border border-[#E2E2E3] rounded-xl cursor-pointer hover:bg-[#F0EDFF] transition-all hover:shadow-md"
          >
            <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="#4F39F6"/>
                <path d="M18 12C18 12.7956 17.8827 13.5587 17.6629 14.2765C17.443 14.9943 17.1262 15.6599 16.7279 16.2426C16.3296 16.8253 15.8551 17.3296 15.3235 17.7371C14.7918 18.1445 14.2087 18.451 13.5918 18.6481" stroke="#4F39F6" strokeWidth="2" strokeLinecap="round"/>
                <path d="M6 12C6 11.2044 6.11733 10.4413 6.33706 9.72346C6.55679 9.00571 6.87357 8.34007 7.27208 7.75736C7.67059 7.17465 8.14509 6.67037 8.67673 6.26293C9.20837 5.8555 9.79134 5.54901 10.4082 5.35188" stroke="#4F39F6" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="text-[14px] md:text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
              Upload File
            </span>
                        <span className="text-[12px] font-medium leading-[14px] tracking-[0.003em] text-[#9340FF] bg-[#F0EDFF] px-3 py-1 rounded-full">
                Coming Soon
              </span>
              {showComingSoon && (
                <div className="fixed top-4 right-4 bg-[#4F39F6] text-white px-4 py-2 rounded-lg text-[14px] font-medium shadow-lg animate-pulse">
                  Coming Soon! We'll add this feature soon.
                </div>
              )}
          </div>

          {/* Evaluation Options Container */}
          <div className="flex flex-col gap-5">
            {/* Talk to Agent */}
            <div 
              onClick={handleTalkToAgent}
              className="flex items-center gap-6 p-6 md:p-7 bg-[#F8F7FF] border border-[#E2E2E3] rounded-xl cursor-pointer hover:bg-[#F0EDFF] transition-all hover:shadow-md"
            >
              <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
                {creatingTalk ? (
                  <svg className="animate-spin h-5 w-5 text-[#4F39F6]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 15.5C21.3845 15.5 22.5 14.3845 22.5 13V11C22.5 9.61547 21.3845 8.5 20 8.5C18.6155 8.5 17.5 9.61547 17.5 11V13C17.5 14.3845 18.6155 15.5 20 15.5Z" fill="#4F39F6"/>
                    <path d="M4 15.5C5.38453 15.5 6.5 14.3845 6.5 13V11C6.5 9.61547 5.38453 8.5 4 8.5C2.61547 8.5 1.5 9.61547 1.5 11V13C1.5 14.3845 2.61547 15.5 4 15.5Z" fill="#4F39F6"/>
                    <path d="M20 13V12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12V13" stroke="#4F39F6" strokeWidth="2"/>
                  </svg>
                )}
              </div>
              <span className="text-[14px] md:text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
                {creatingTalk ? "Creating session..." : `Talk With ${agentDetails.agent_name}`}
              </span>
            </div>

            {/* Chat with Agent */}
            <div 
              onClick={handleChatWithAgent}
              className="flex items-center gap-6 p-6 md:p-7 bg-[#F8F7FF] border border-[#E2E2E3] rounded-xl cursor-pointer hover:bg-[#F0EDFF] transition-all hover:shadow-md"
            >
              <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
                {creatingChat ? (
                  <svg className="animate-spin h-5 w-5 text-[#4F39F6]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="#4F39F6"/>
                  </svg>
                )}
              </div>
              <span className="text-[14px] md:text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
                {creatingChat? "Creating session..." : `Video Chat With ${agentDetails.agent_name}`}
              </span>
            </div>

            {/* Video Call with Agent */}
            {/* <div 
              onClick={handleVideoCallWithAgent}
              className="flex items-center gap-6 p-6 bg-[#F8F7FF] border border-[#E2E2E3] rounded-lg cursor-pointer hover:bg-[#F0EDFF] transition-colors relative"
            >
              <div className="w-10 h-10 bg-[#E6E2FF] rounded-lg flex items-center justify-center flex-shrink-0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M17 10.5V7C17 5.9 16.1 5 15 5H1C0.45 5 0 5.45 0 6V18C0 18.55 0.45 19 1 19H15C16.1 19 17 18.1 17 17V13.5L23 17V7L17 10.5Z" fill="#4F39F6"/>
                </svg>
              </div>
              <div className="flex-1">
                <span className="text-[14px] md:text-[16px] font-semibold leading-[19px] tracking-[0.003em] text-[#373737]">
                  Video Call with {agentDetails.agent_name}
                </span>
              </div>
              <span className="text-[12px] font-medium leading-[14px] tracking-[0.003em] text-[#9340FF] bg-[#F0EDFF] px-3 py-1 rounded-full">
                Coming Soon
              </span>
              {showComingSoon && (
                <div className="fixed top-4 right-4 bg-[#4F39F6] text-white px-4 py-2 rounded-lg text-[14px] font-medium shadow-lg animate-pulse">
                  Coming Soon! We'll add this feature soon.
                </div>
              )}
            </div> */}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-6 mt-6">
            <button 
              onClick={handleBack}
              className="flex-1 flex items-center justify-center px-6 py-3.5 h-12 bg-[#E6E2FF] rounded-xl hover:bg-[#D9D4FF] transition-all hover:shadow-md"
            >
              <span className="text-[14px] md:text-[15px] font-semibold leading-[18px] text-[#4F39F6]">Explore Agents</span>
            </button>
          </div>

          {/* My Sessions Section */}
          {/* <div className="mt-4">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-[16px] md:text-[18px] font-semibold text-[#373737]">My Sessions</h2>
              {sessionsLoading && (
                <span className="text-xs text-gray-500">Loading…</span>
              )}
            </div>
            {(!sessionsLoading && mySessions.length === 0) ? (
              <div className="text-sm text-gray-600 bg-white border border-gray-200 rounded-lg p-4">
                No sessions with this agent yet.
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {mySessions.map((s) => (
                  <div
                    key={s.session_id || s.id}
                    className="bg-white border border-gray-200 rounded-lg p-4 cursor-pointer hover:shadow-sm"
                    onClick={() => navigate(`/conversation/${s.session_id || s.id}`, {
                      state: {
                        agentId: id,
                        agentName: agentDetails?.agent_name,
                      }
                    })}
                  >
                    <div className="text-sm font-semibold text-gray-800 truncate">
                      {s.session_name || agentDetails?.agent_name || 'Session'}
                    </div>
                    <div className="text-xs text-gray-600 mt-1">
                      {(s.created_at && new Date(s.created_at).toLocaleString()) || ''}
                    </div>
                    {s.pdf_count != null && (
                      <div className="text-xs text-gray-500 mt-1">PDFs: {s.pdf_count}</div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div> */}
        </div>
      </div>

      {/* File Upload Modal */}
      <FileUploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        agentId={id}
        agentName={agentDetails?.agent_name}
      />
    </div>
  );
}